/**
 * @generated SignedSource<<76eeb486d41eb96d09459eee164f7904>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectDirectoryLayout$data = {
  readonly jira: {
    readonly allJiraProjects: {
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectsList">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProjectDirectoryLayout";
};
export type ProjectDirectoryLayout$key = {
  readonly " $data"?: ProjectDirectoryLayout$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectDirectoryLayout">;
};

import ProjectDirectoryRefetchQuery_graphql from './ProjectDirectoryRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "filter"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAdminSettingsContext"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": ProjectDirectoryRefetchQuery_graphql
    }
  },
  "name": "ProjectDirectoryLayout",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "filter",
              "variableName": "filter"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            },
            {
              "kind": "Variable",
              "name": "last",
              "variableName": "last"
            }
          ],
          "concreteType": "JiraProjectConnection",
          "kind": "LinkedField",
          "name": "allJiraProjects",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isAdminSettingsContext",
                  "variableName": "isAdminSettingsContext"
                }
              ],
              "kind": "FragmentSpread",
              "name": "ProjectsList"
            },
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "ff5aba3744cc1b7927986c5dabbcf1dd";

export default node;
